var $70037a741b152768$exports = {};
$70037a741b152768$exports = {
  "help": `Pomoc`,
  "info": `Inform\xe1cie`
};
export { $70037a741b152768$exports as default };